import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import "./HomeEspace.css";
import axios from "axios";
import HistoriqueVisiteur from "../../../../Services/Visiteure/HistoriqueVisiteur";

const visiteurId = localStorage.getItem("VisiteurId") ?? "";

const MenuEspace = () => {
  const location = useLocation();
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  const [devisCount, setDevisCount] = useState<number>(0);
  const [historiqueCount, setHistoriqueCount] = useState<number>(0);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    // Fetch counts
    if (visiteurId) {
      axios.get(`${process.env.REACT_APP_PHP_APP_URL}/visiteur/${visiteurId}/devis`)
        .then(res => setDevisCount(res.data.filter((d: any) => d.status === 'en cours').length))
        .catch(err => console.error(err));
        
      HistoriqueVisiteur().getHistoriqueVisiteur()
        .then(res => setHistoriqueCount(res.data.length))
        .catch(err => console.error(err));
    }

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  if (screenWidth <= 450){
    return <>
     <div className="mobile-dashboard-visiteurinter">
      <nav className="mobile-navbar-visiteurinter">
        <NavLink to={`/visiteur/${visiteurId}/espace/devis`}>
          <div
            className={
              location.pathname === `/visiteur/${visiteurId}/espace/devis`
                ? "mobile-nav-item active-mobile"
                : "mobile-nav-item"
            }
          >
            <div className="icon-wrapper-espace">
              <i className="bi bi-file-earmark-text-fill"></i>
              {devisCount > 0 && <span className="badge-count-espace">{devisCount}</span>}
            </div>
            <span>Devis</span>
          </div>
        </NavLink>

        <NavLink to={`/visiteur/${visiteurId}/espace/historiques`}>
          <div
            className={
              location.pathname ===
              `/visiteur/${visiteurId}/espace/historiques`
                ? "mobile-nav-item active-mobile"
                : "mobile-nav-item"
            }
          >
            <div className="icon-wrapper-espace">
              <i className="bi bi-calendar4-week"></i>
              {historiqueCount > 0 && <span className="badge-count-espace">{historiqueCount}</span>}
            </div>
            <span>Historique</span>
          </div>
        </NavLink>

        <NavLink to={`/visiteur/${visiteurId}/profile`}>
          <div
            className={
              location.pathname === `/visiteur/${visiteurId}/profile`
                ? "mobile-nav-item active-mobile"
                : "mobile-nav-item"
            }
          >
            <i className="bi bi-person-circle"></i>
            <span>Mon Profil</span>
          </div>
        </NavLink>

        <NavLink to={`/visiteur/${visiteurId}/support`}>
          <div
            className={
              location.pathname === `/visiteur/${visiteurId}/support`
                ? "mobile-nav-item active-mobile"
                : "mobile-nav-item"
            }
          >
            <i className="bi bi-headset"></i>
            <span>Support</span>
          </div>
        </NavLink>

        <NavLink to={`/logout`}>
          <div
            className={
              location.pathname === `/logout`
                ? "mobile-nav-item active-mobile"
                : "mobile-nav-item"
            }
          >
            <i className="bi bi-box-arrow-left"></i>
            <span>Déconnexion</span>
          </div>
        </NavLink>
      </nav>
    </div>
    </>
  }
  return (
    <div className="dashboard-visiteurinter">
      <div className="sidebar-visiteurinter">
        <h3 className="sidebar-title-visiteurinter">Wyn</h3>
        <ul className="sidebar-menu-visiteurinter">
          <NavLink to={`/visiteur/${visiteurId}/espace/devis`}>
            <li
              className={
                location.pathname === `/visiteur/${visiteurId}/espace/devis`
                  ? "active-visiteurinter"
                  : ""
              }
            >
              <div style={{display: 'flex', alignItems: 'center', gap: '12px', flex: 1}}>
                <div className="icon-wrapper-espace">
                  <i className="bi bi-file-earmark-text-fill"></i>
                  {devisCount > 0 && <span className="badge-count-espace desktop-badge-espace">{devisCount}</span>}
                </div>
                <span>Devis</span>
              </div>
            </li>
          </NavLink>

          <NavLink to={`/visiteur/${visiteurId}/espace/historiques`}>
            <li
              className={
                location.pathname ===
                `/visiteur/${visiteurId}/espace/historiques`
                  ? "active-visiteurinter"
                  : ""
              }
            >
              <div style={{display: 'flex', alignItems: 'center', gap: '12px', flex: 1}}>
                <div className="icon-wrapper-espace">
                  <i className="bi bi-calendar4-week"></i>
                  {historiqueCount > 0 && <span className="badge-count-espace desktop-badge-espace">{historiqueCount}</span>}
                </div>
                <span>Historique</span>
              </div>
            </li>
          </NavLink>

          <NavLink to={`/visiteur/${visiteurId}/profile`}>
            <li
              className={
                location.pathname === `/visiteur/${visiteurId}/profile`
                  ? "active-visiteurinter"
                  : ""
              }
            >
              <i className="bi bi-person-circle"></i>
              <span>Mon Profil</span>
            </li>
          </NavLink>

          <NavLink to={`/visiteur/${visiteurId}/support`}>
            <li
              className={
                location.pathname === `/visiteur/${visiteurId}/support`
                  ? "active-visiteurinter"
                  : ""
              }
            >
              <i className="bi bi-headset"></i>
              <span>Support & Réclamation</span>
            </li>
          </NavLink>

          <NavLink to={`/logout`}>
            <li
              className={
                location.pathname === `/logout`
                  ? "active-visiteurinter logout-btn"
                  : "logout-btn"
              }
            >
              <i className="bi bi-box-arrow-left"></i>
              <span>Déconnexion</span>
            </li>
          </NavLink>
        </ul>
      </div>
    </div>
  );
};

export default MenuEspace;
